<template>
  <div>
    <div
      class="backToBiblio"
      id="backToBiblio"
      v-if="RouteFromBiblio"
      v-on:click="backToBiblioSegment()"
      style="margin-left: 50px;"
    >
      <svg
        width="100px"
        height="30px"
        viewBox="0 0 100 30"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g>
            <rect
              stroke="#FFFFFF"
              stroke-width="1"
              x="0.5"
              y="0.5"
              width="99"
              height="29"
              rx="6"
            ></rect>
            <g transform="translate(16.000000, 7.000000)" fill="#FFFFFF" fill-rule="evenodd">
              <path
                d="M15.1714286,7.71428571 L5.29714286,7.71428571 L7.67314286,5.33828571 C7.87577143,5.13565714 7.97142857,4.89394286 7.97142857,4.62857143 C7.97142857,4.12251429 7.55331429,3.6 6.94285714,3.6 C6.66977143,3.6 6.43165714,3.69925714 6.23314286,3.89828571 L2.14045714,7.99097143 C1.97177143,8.15965714 1.8,8.36794286 1.8,8.74285714 C1.8,9.11777143 1.94348571,9.29828571 2.13222857,9.48702857 L6.23314286,13.5874286 C6.43165714,13.7864571 6.66977143,13.8857143 6.94285714,13.8857143 C7.55382857,13.8857143 7.97142857,13.3632 7.97142857,12.8571429 C7.97142857,12.5917714 7.87577143,12.3500571 7.67314286,12.1474286 L5.29714286,9.77142857 L15.1714286,9.77142857 C15.7392,9.77142857 16.2,9.31062857 16.2,8.74285714 C16.2,8.17508571 15.7392,7.71428571 15.1714286,7.71428571 Z"
                id="Path"
              ></path>
            </g>
            <text
              font-family="RobotoUep!important"
              font-size="13"
              font-weight="700"
              letter-spacing="-0.336"
              fill="#FFFFFF"
            >
              <tspan x="39" y="20">{{ $t('button.back') }}</tspan>
            </text>
          </g>
        </g>
      </svg>
    </div>
    <div
      style="margin-left: 50px;"
      class="panel__title_page"
      id="panel__title_page"
      :class="{ 'edit-mode': isEditMode, 'back-route': RouteFromBiblio }"
    >
      <div class="show-panel" v-if="!isSegment && !isEditMode">
        <span class="show-panel__span">{{ title }}</span>
        <span class="fa fa-pencil panel__title_edit" @click="toggleEditModeTemplate()"> </span>
      </div>

      <div class="show-panel" v-if="!isEditMode && isSegment">
        <span class="show-panel__span">{{ titleSegment }}</span>
        <span class="fa fa-pencil panel__title_edit" @click="toggleEditModeSegment()"> </span>
      </div>

      <div class="edit-panel" v-show="!isSegment">
        <div class="save-btn fa fa-save" @click="updateTemplate()"></div>
        <div class="close-btn fa fa-times-circle" @click="toggleEditModeTemplate(true)"></div>
        <input
          :title="$t('panels.title')"
          :placeholder="$t('panels.title')"
          type="text"
          class="form-control"
          v-model="title"
        />
      </div>

      <div class="edit-panel" v-show="isSegment">
        <div class="save-btn fa fa-save" @click="updateSegment()"></div>
        <div class="close-btn fa fa-times-circle" @click="toggleEditModeSegment(true)"></div>
        <input
          :title="$t('panels.title')"
          :placeholder="$t('panels.title')"
          type="text"
          class="form-control"
          v-model="titleSegment"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import en from '../../i18n/en_US';
import fr from '../../i18n/fr_FR';
export default {
  data() {
    return {
      isEditMode: false,
      title: '',
      oldTitle: '',
      titleSegment: '',
      oldTitleSegment: '',
    };
  },
  i18n: {
    messages: {
      en,
      fr,
    },
  },
  watch: {
    template: {
      handler(val) {
        if(val){
        this.title = val.title;
        }
      },
      deep: true,
    },
    segment: {
      handler(val) {
        if(val){
        this.titleSegment = val.title;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      template: 'slides/getTemplate',
      paramsClient: 'getParamsClients',
      permissions: 'getPermissions',
      segment: 'segments/getCurrent',
      RouteFromBiblio: 'segments/getFromRouteBiblio',
    }),

    isSegment() {
      if (this.$route.name === 'segment') return true;
      else return false;
    },
  },
  methods: {
    ...mapActions('slides', ['updatePogramTitle']),
    ...mapActions('segments', ['setCurrentSegmentTitle']),
    toggleEditModeTemplate(cancel = false) {
      if (cancel) {
        this.title = this.oldTitle;
      } else {
        this.oldTitle = this.title;
      }
      this.isEditMode = !this.isEditMode;
    },
    toggleEditModeSegment(cancel = false) {
      if (cancel) {
        this.titleSegment = this.oldTitleSegment;
      } else {
        this.oldTitleSegment = this.titleSegment;
      }
      this.isEditMode = !this.isEditMode;
    },
    updateTemplate() {
      this.updatePogramTitle(this.title);
      eventHub.$emit('updateTitleSegment', this.title);
      this.toggleEditModeTemplate();
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    updateSegment() {
      this.setCurrentSegmentTitle(this.titleSegment);
      this.toggleEditModeSegment();
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    backToBiblioSegment() {
      this.$root.$emit('bv::show::modal', 'modal-exit-save', '#backToBiblio');
      /*
      if (this.segment.id)
        this.$router.push({ name: 'EditSegment', params: { id: this.segment.id } });
      else this.$router.push({ name: 'AddSegment' });
    */
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-full-screen {
  background-color: aqua;
  width: 40px;
  height: 40px;
  position: absolute;
  z-index: 9;
}
.backToBiblio {
  position: absolute;
  z-index: 5;
  margin: 0.3em;
  :hover {
    cursor: pointer;
  }
}
.back-route {
  left: 7em !important;
}

.panel__title_page {
  position: absolute;
  color: white;
  z-index: 4;
  padding: 8px;
  left: 5px;
  font-weight: 600;
  max-width: 35%;
}
.panel__title_edit {
  cursor: pointer;
  padding: 5px;
}
.edit-mode {
  .edit-panel {
    opacity: 1;
    visibility: visible;
  }
}
.edit-panel {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  padding: 0 0.5em;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s;
  min-width: 200px;

  .close-btn {
    position: absolute;
    right: -45px;
    padding: 5px 0;
    top: 0;
    height: 25px;
    width: 25px;
    z-index: 1;
    line-height: 2em;
    color: #fff;
    cursor: pointer;
    &:hover {
    }
  }
  .save-btn {
    position: absolute;
    right: -23px;
    padding: 5px 0;
    top: 0;
    height: 25px;
    width: 25px;
    z-index: 1;
    line-height: 2em;
    color: #fff;
    cursor: pointer;
  }
  .form-control {
    background: transparent;
    height: 30px;
    margin: 5px;
    border: 1px solid #fff;
    color: #fff;
  }
}
.show-panel {
  display: flex;
  flex-direction: row;
  &__span {
    white-space: nowrap;
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    -webkit-line-clamp: 3;
    -o-text-overflow: ellipsis;
    line-height: 1.5em;
  }
}
</style>



// WEBPACK FOOTER //
// PanelTitlePages.vue?44c69cbb